/* Starts the details video only once its slot is actually on screen.
   The markup carries no `autoplay` attribute on purpose (that attribute makes
   the browser buffer the file immediately, wherever the slot sits on the page),
   so without this the video stays on its poster. Reduced-motion viewers never
   get autoplay; they (and anyone whose autoplay attempt is refused, or whose
   browser lacks IntersectionObserver) get a tap-to-play button instead. */
(function () {
  if (window.signatureVideoInit) return;
  window.signatureVideoInit = true;

  function showButton(button) {
    if (button) button.hidden = false;
  }

  function hideButton(button) {
    if (button) button.hidden = true;
  }

  function attemptPlay(video, button) {
    var played = video.play();
    if (played && played.catch) {
      played.catch(function (error) {
        video.setAttribute('data-play-blocked', (error && error.name) || 'unknown');
        console.debug('Signature video play() was blocked:', error);
        showButton(button);
      });
    }
  }

  function arm() {
    var videos = document.querySelectorAll('[data-signature-video]');
    if (!videos.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    videos.forEach(function (video) {
      var button = video.parentElement
        ? video.parentElement.querySelector('[data-signature-video-play]')
        : null;

      function manualPlay() {
        if (video.preload === 'none') video.preload = 'auto';
        attemptPlay(video, button);
      }

      video.addEventListener('playing', function () {
        hideButton(button);
      });
      video.addEventListener('click', manualPlay);
      if (button) button.addEventListener('click', manualPlay);

      if (reducedMotion) {
        // Never autoplay for these viewers; the button is the only way in.
        showButton(button);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        // Nothing will start the video on its own, so offer the button
        // rather than leaving a poster no one can act on.
        showButton(button);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== video) return;
            if (entry.isIntersecting) {
              if (video.preload === 'none') video.preload = 'auto';
              attemptPlay(video, button);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
